export default __webpack_public_path__ + "static/media/icon2.c4877566.svg";